import styled from 'styled-components'

export const WarningMessage = styled.h3`
  margin-top: 40px;
  color: ${(props) => props.theme.colors.error};
`

export const ScrollArea = styled.div`
  max-height: 420px;
  overflow-y: auto;
  margin: 8px 0;
  padding-right: 8px;
`

export const SectionTitle = styled.h4`
  margin: 16px 0 6px;
  color: #333;
`

export const Block = styled.div`
  border: 1px solid ${(props) => props.theme.colors.scale[500]};
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
`

export const BlockList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`

export const PlanItem = styled.li`
  border-bottom: 1px solid ${(props) => props.theme.colors.scale[500]};
  &:last-child { border-bottom: none; }
`

export const FactorRow = styled.div`
  display: grid;
  grid-template-columns: 160px 1fr;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #fff;
`

export const PlanHeader = styled.div`
  padding: 8px 12px;
  font-weight: 600;
  background: #f7f7f8;
  border-bottom: 1px solid ${(props) => props.theme.colors.scale[500]};
`

export const SizeRow = styled.div`
  display: grid;
  grid-template-columns: 160px 1fr 16px 1fr;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #fff;
  & + & { border-top: 1px solid ${(props) => props.theme.colors.scale[500]}; }
`